<div class="section mt-2">
  <div class="card">
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-10">
          <h4>Notes</h4>
        </div>
      </div>

      <div class="section mt-2">
        <app-notes-for-model [model]="provider" [modelType]="'Provider'" />
      </div>
    </div>
  </div>
</div>

@if (showSpecialistDetectionLlmResults) {
  <div class="section mt-2">
    <div class="card">
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-10">
            <h4>LLM Specialist Detection</h4>
          </div>
        </div>

        <div class="section mt-2">
          <table class="table table-bordered table-sm">
            <thead class="table-dark">
              <tr>
                <th>DATE</th>
                <th>RESULT</th>
                <th>SPECIALTY</th>
              </tr>
            </thead>
            <tbody>
              @for (result of provider.llmSpecialistDetectionResults; track result.id) {
                <tr>
                  <td>{{ result.createdAt | date: 'M/d/yyyy' }}</td>
                  <td>{{ result.choiceResponse?.specialistStatus | blankValueDash }}</td>
                  <td>{{ result.choiceResponse?.specialty | blankValueDash }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
}

<div class="section mt-2">
  <div class="card">
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-10">
          <h4>Offices</h4>
        </div>

        <div class="col-2 actions">
          <button
            class="btn btn-primary"
            [disabled]="showAddOffices"
            (click)="onAddNewOfficesClick()">
            Add Offices
          </button>
        </div>
      </div>

      @if (showAddOffices) {
        <app-provider-office-new-form
          [provider]="provider"
          [providerOffices]="providerOffices"
          (providerAdded)="onOfficeAdded()"
          (completed)="onOfficeFormCompleted()" />
      }

      <app-provider-office-list
        [loading]="providerOfficesLoading"
        [providerOffices]="providerOffices" />
    </div>
  </div>
</div>

<div class="section mt-2">
  @if (provider.informationCollectionDetails) {
    <div class="card bg-light">
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-10">
            <h4>Mechanical Turk HIT Details</h4>
          </div>
        </div>
        <div class="m-3">
          <app-provider-information-collection-details
            [provider]="provider" />
        </div>
      </div>
    </div>
  }
</div>
